import { Box, Flex, IconButton, Image, Text } from '@chakra-ui/react'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'

const Annotation = ({ x, y, label }) => {
  return (
    <Flex
      position="absolute"
      zIndex={9999}
      top={y}
      left={x}
      opacity={0}
      transitionProperty="transform, opacity"
      transitionDuration="slow"
      transitionTimingFunction="ease"
      transform="scale(.9)"
      _hover={{
        transform: 'scale(1)',
      }}
      _groupHover={{
        opacity: 1,
      }}
      align="center"
      direction="column"
      sx={{
        '&:hover .annotationLabel': {
          opacity: 1,
          transform: 'scale(1)',
        },
      }}
    >
      <IconButton
        aria-label="icbtn"
        icon={<FontAwesomeIcon icon={faCircle} />}
        isRound
        size="xs"
        variant="outline"
        color="white"
        shadow="base"
        bg="rgba(255,255,255,.3)"
      ></IconButton>
      <Box
        className="annotationLabel"
        bg="white"
        color="gray.900"
        mt={-14}
        px={2}
        py={1}
        position="absolute"
        whiteSpace="nowrap"
        borderRadius="base"
        shadow="md"
        opacity={0}
        transform="scale(.8)"
        transitionProperty="transform, opacity"
        transitionDuration="normal"
        transitionTimingFunction="ease"
      >
        {label}
      </Box>
    </Flex>
  )
}

const ThreeDCardImage = ({ layer0, layer1, width, height }) => {
  return (
    <>
      <Box position="relative" display="block">
        <Image
          className="atvImg-fallback"
          src="https://cdn.gamma.app/zc87vhr30n8uf3n/c8/63fae5b5d0430c9a9f7256bd76f0f3/teamphoto.jpg"
          alt="Team photo"
        />
        <Box
          className="atvImg"
          w={width || '100%'}
          h={height || '500px'}
          onMouseMove={(event) => {}}
          role="group"
        >
          {layer0 && <Box className="atvImg-layer" data-img={layer0}></Box>}
          {layer1 && (
            <div className="atvImg-layer" data-img={layer1}>
              <Annotation
                x={110}
                y={180}
                label={
                  <>
                    <Text>Ali</Text>
                    <Text fontSize="sm" color="gray.500">
                      The Problem Solver
                    </Text>
                  </>
                }
              />
              <Annotation
                x={234}
                y={165}
                label={
                  <>
                    <Text>James</Text>
                    <Text fontSize="sm" color="gray.500">
                      The Gadget Guy
                    </Text>
                  </>
                }
              />
              <Annotation
                x={325}
                y={190}
                label={
                  <>
                    <Text>Jon</Text>
                    <Text fontSize="sm" color="gray.500">
                      The Cat Herder
                    </Text>
                  </>
                }
              />
              <Annotation
                x={370}
                y={180}
                label={
                  <>
                    <Text>Jess</Text>
                    <Text fontSize="sm" color="gray.500">
                      The Influencer
                    </Text>
                  </>
                }
              />
              <Annotation
                x={435}
                y={160}
                label={
                  <>
                    <Text>Grant</Text>
                    <Text fontSize="sm" color="gray.500">
                      The Mastermind
                    </Text>
                  </>
                }
              />
              <Annotation
                x={530}
                y={175}
                label={
                  <>
                    <Text>Zach</Text>
                    <Text fontSize="sm" color="gray.500">
                      The Inside Man
                    </Text>
                  </>
                }
              />
              <Annotation
                x={605}
                y={135}
                label={
                  <>
                    <Text>Travis</Text>
                    <Text
                      fontSize="sm"
                      color="gray.500"
                      minWidth="150px"
                      whiteSpace="pre-wrap"
                    >
                      The Straight-shooting Veteran
                    </Text>
                  </>
                }
              />
            </div>
          )}
        </Box>
      </Box>
    </>
  )
}

export default function App() {
  useEffect(() => {
    atvImg()
  }, [])

  return (
    <Flex
      p={12}
      bg="#faf2e9"
      minH="100vh"
      minW="100vw"
      align="center"
      justify="center"
      direction="column"
    >
      <Flex flex="1" align="center" justify="center">
        <ThreeDCardImage
          width="685px"
          height="514px"
          layer0="https://cdn.gamma.app/zc87vhr30n8uf3n/1a/d653592e054b46b98f455a31e0fc2e/image.png"
          layer1="https://cdn.gamma.app/zc87vhr30n8uf3n/50/dbe0f569624802a1ee73526e6de82d/image.png"
        />
      </Flex>
      <Flex>
        <Box w="35px">{/* <Logo /> */}</Box>
      </Flex>
    </Flex>
  )
}

const Logo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 33" {...props}>
      <polygon
        points="13.97 27.59 13.97 32.16 0.11 24.16 0.11 8.16 13.97 0.16 17.93 2.45 4.07 10.45 4.07 21.88 13.97 27.59"
        style={{ fill: '#a6a6a6' }}
      />
      <polyline
        points="4.07 21.88 13.97 27.59 13.97 32.16 0.11 24.16"
        style={{ fill: '#b3b3b3' }}
      />
      <polygon
        points="13.97 16.16 13.97 20.74 23.87 15.02 23.87 21.88 13.97 27.59 13.97 32.16 27.83 24.16 27.83 8.16 13.97 16.16"
        style={{ fill: '#bfbfbf' }}
      />
      <polygon
        points="17.93 2.45 17.93 7.02 8.03 12.74 8.03 19.59 4.07 21.88 4.07 10.45 17.93 2.45"
        style={{ fill: '#ccc' }}
      />
      <polygon
        points="19.91 17.31 19.91 19.59 23.87 21.88 23.87 15.02 19.91 17.31"
        style={{ fill: '#ccc' }}
      />
      <polygon
        points="10.01 13.88 10.01 18.45 13.97 20.74 13.97 16.16 10.01 13.88"
        style={{ fill: '#e6e6e6' }}
      />
      <polygon
        points="10.01 13.88 13.97 16.16 27.83 8.16 23.87 5.88 10.01 13.88"
        style={{ fill: '#d9d9d9' }}
      />
      <polygon
        points="4.07 21.88 13.97 27.59 23.87 21.88 19.91 19.59 13.97 23.02 8.03 19.59 4.07 21.88"
        style={{ fill: '#e6e6e6' }}
      />
    </svg>
  )
}

/* eslint-disable */
const atvImg = () => {
  var d = document,
    de = d.documentElement,
    bd = d.getElementsByTagName('body')[0],
    htm = d.getElementsByTagName('html')[0],
    win = window,
    imgs = d.querySelectorAll('.atvImg'),
    totalImgs = imgs.length,
    supportsTouch = 'ontouchstart' in win || navigator.msMaxTouchPoints

  if (totalImgs <= 0) {
    return
  }

  // build HTML
  for (var l = 0; l < totalImgs; l++) {
    var thisImg = imgs[l],
      layerElems = thisImg.querySelectorAll('.atvImg-layer'),
      totalLayerElems = layerElems.length

    if (totalLayerElems <= 0) {
      continue
    }

    while (thisImg.firstChild) {
      thisImg.removeChild(thisImg.firstChild)
    }

    var containerHTML = d.createElement('div'),
      shineHTML = d.createElement('div'),
      shadowHTML = d.createElement('div'),
      layersHTML = d.createElement('div'),
      layers = []

    thisImg.id = 'atvImg__' + l
    containerHTML.className = 'atvImg-container'
    shineHTML.className = 'atvImg-shine'
    shadowHTML.className = 'atvImg-shadow'
    layersHTML.className = 'atvImg-layers'

    for (var i = 0; i < totalLayerElems; i++) {
      var layer = d.createElement('div'),
        imgSrc = layerElems[i].getAttribute('data-img'),
        textContents = layerElems[i].getAttribute('data-text')

      layer.className = 'atvImg-rendered-layer'
      layer.setAttribute('data-layer', i)
      layer.style.backgroundImage = 'url(' + imgSrc + ')'
      layersHTML.appendChild(layer)

      if (textContents) {
        layer.classList.add('atv-layer-has-text')
        var textEl = document.createElement('div')
        textEl.className = 'atvImg-text'
        var textNode = document.createTextNode(textContents)
        textEl.appendChild(textNode)
        layer.appendChild(textEl)
      }

      // Extras
      while (layerElems[i].childNodes.length > 0) {
        layer.appendChild(layerElems[i].childNodes[0])
      }

      layers.push(layer)
    }

    containerHTML.appendChild(shadowHTML)
    containerHTML.appendChild(layersHTML)
    containerHTML.appendChild(shineHTML)
    thisImg.appendChild(containerHTML)

    var w = thisImg.clientWidth || thisImg.offsetWidth || thisImg.scrollWidth
    thisImg.style.transform = 'perspective(' + w * 3 + 'px)'

    if (supportsTouch) {
      win.preventScroll = false
      ;(function (_thisImg, _layers, _totalLayers, _shine) {
        thisImg.addEventListener('touchmove', function (e) {
          if (win.preventScroll) {
            e.preventDefault()
          }
          processMovement(e, true, _thisImg, _layers, _totalLayers, _shine)
        })
        thisImg.addEventListener('touchstart', function (e) {
          win.preventScroll = true
          processEnter(e, _thisImg)
        })
        thisImg.addEventListener('touchend', function (e) {
          win.preventScroll = false
          processExit(e, _thisImg, _layers, _totalLayers, _shine)
        })
      })(thisImg, layers, totalLayerElems, shineHTML)
    } else {
      ;(function (_thisImg, _layers, _totalLayers, _shine) {
        thisImg.addEventListener('mousemove', function (e) {
          processMovement(e, false, _thisImg, _layers, _totalLayers, _shine)
        })
        thisImg.addEventListener('mouseenter', function (e) {
          processEnter(e, _thisImg)
        })
        thisImg.addEventListener('mouseleave', function (e) {
          processExit(e, _thisImg, _layers, _totalLayers, _shine)
        })
      })(thisImg, layers, totalLayerElems, shineHTML)
    }
  }

  function processMovement(e, touchEnabled, elem, layers, totalLayers, shine) {
    var bdst = bd.scrollTop || htm.scrollTop,
      bdsl = bd.scrollLeft,
      pageX = touchEnabled ? e.touches[0].pageX : e.pageX,
      pageY = touchEnabled ? e.touches[0].pageY : e.pageY,
      offsets = elem.getBoundingClientRect(),
      w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth, // width
      h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight, // height
      wMultiple = 320 / w,
      offsetX = 0.52 - (pageX - offsets.left - bdsl) / w, //cursor position X
      offsetY = 0.52 - (pageY - offsets.top - bdst) / h, //cursor position Y
      dy = pageY - offsets.top - bdst - h / 2, //@h/2 = center of container
      dx = pageX - offsets.left - bdsl - w / 2, //@w/2 = center of container
      yRotate = (offsetX - dx) * (0.07 * wMultiple), //rotation for container Y
      xRotate = (dy - offsetY) * (0.1 * wMultiple), //rotation for container X
      imgCSS = 'rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg)', //img transform
      arad = Math.atan2(dy, dx), //angle between cursor and center of container in RAD
      angle = (arad * 180) / Math.PI - 90 //convert rad in degrees
    //get angle between 0-360
    if (angle < 0) {
      angle = angle + 360
    }

    //container transform
    if (elem.firstChild.className.indexOf(' over') != -1) {
      imgCSS += ' scale3d(1.07,1.07,1.07)'
    }
    elem.firstChild.style.transform = imgCSS

    //gradient angle and opacity for shine
    shine.style.background =
      'linear-gradient(' +
      angle +
      'deg, rgba(255,255,255,' +
      ((pageY - offsets.top - bdst) / h) * 0.4 +
      ') 0%,rgba(255,255,255,0) 80%)'
    shine.style.transform =
      'translateX(' +
      offsetX * totalLayers -
      0.1 +
      'px) translateY(' +
      offsetY * totalLayers -
      0.1 +
      'px)'

    //parallax for each layer
    var revNum = totalLayers
    for (var ly = 0; ly < totalLayers; ly++) {
      layers[ly].style.transform =
        'translateX(' +
        offsetX * revNum * ((ly * 2.5) / wMultiple) +
        'px) translateY(' +
        offsetY * totalLayers * ((ly * 2.5) / wMultiple) +
        'px)'
      revNum--
    }
  }

  function processEnter(e, elem) {
    elem.firstChild.className += ' over'
  }

  function processExit(e, elem, layers, totalLayers, shine) {
    var container = elem.firstChild

    container.className = container.className.replace(' over', '')
    container.style.transform = ''
    shine.style.cssText = ''

    for (var ly = 0; ly < totalLayers; ly++) {
      layers[ly].style.transform = ''
    }
  }
}
